import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { ConfigurationService } from '@bytel/checkout';

import { GraphQLRepository } from '@repositories/graphql.repository';

import { Observable } from 'rxjs';

import { InfoWithPepitesItem } from '../interfaces/directus-cms.interface';

@Injectable({
    providedIn: 'root',
})
export class PepitesService {
    protected config: ConfigurationService = inject(ConfigurationService);
    protected graphQLRepository: GraphQLRepository = inject(GraphQLRepository);
    protected http: HttpClient = inject(HttpClient);

    public getBtbdPepites(slug: string): Observable<InfoWithPepitesItem> {
        const urlApi = this.config.getData()?.global.contentEditor.checkoutApiBaseUrl;

        return this.http.get<InfoWithPepitesItem>(`${urlApi}/btbd/${slug}`);
    }
}
